import { useStandingData } from "stuffjs";

import { useLRStoreRefs } from "../store/lr-store";

export const useLiveResultStandingData = () => {
    const { standingData } = useLRStoreRefs();
    return useStandingData(standingData);
};
